<template>

  <v-app id="admin-wrapper">

    <Drawer />

    <v-main class="grey lighten-2">

      <v-breadcrumbs :items="visibleBreadcrumbs" class="pb-0 justify-end" large>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.to"
            :disabled="item.disabled"
            :title="item.text"
            exact
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>

      <router-view></router-view>

      <Footer />

    </v-main>

    <v-overlay :value="loading" z-index="1000" opacity="0.1">
      <v-progress-circular indeterminate size="350" width="6" color="primary">
        <v-img
          :src="require('#Components/assets/logo.png')"
          contain
          height="200"
        />
      </v-progress-circular>
    </v-overlay>

    <Notifier />

  </v-app>

</template>

<script>
import { mapGetters } from 'vuex'
import Drawer from '#Components/admin/structure/Drawer'
import Footer from '#Components/admin/structure/Footer'
import Notifier from '#Components/admin/structure/Notifier'

export default {

  name: 'Admin_Wrapper',

  components: {
    Drawer,
    Footer,
    Notifier
  },

  data: () => ({ 
    
  }),

  computed: {
    ...mapGetters('app', ['breadcrumbs', 'loading']),
    visibleBreadcrumbs() {
      return this.breadcrumbs.reverse()
    }
  }

}
</script>